import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import waterVertexShader from './shaders/water/vertex.glsl'
import waterFragmentShader from './shaders/water/fragment.glsl'

/**
 * Base
 */
// Debug
const gui = new GUI({ width: 340 })
const debugObject = {}

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Water
 */
// Geometry
const resolution = 128 * 8 * 2
const size = 5
console.log(resolution)
const waterGeometry = new THREE.PlaneGeometry(size, size, resolution, resolution)

// Color
debugObject.surfaceColor = '#9bd8ff'
debugObject.depthColor   = '#1a6289'

// Material
const waterMaterial = new THREE.ShaderMaterial({
    vertexShader: waterVertexShader,
    fragmentShader: waterFragmentShader,
    uniforms: 
    {
        uTime: { value : 0 },

        // big wave
        uBigWavesElevation: { value : 0.23 },
        uBigWavesFrequency: { value : new THREE.Vector2(2.21, 1.36)},
        uBigWavesSpeed: { value : 0.58},

        // small wave
        uSmallWavesElevation: { value : 0.13 },
        uSmallWavesFrequency: { value : 1.98 },
        uSmallWavesSpeed: { value : 0.2},
        uSmallWavesIteration: { value : 6},

        // foam
        uFoamBrightness: { value : 9.69 },
        uFoamOffset: { value : 0.74 },

        // color
        uSurfaceColor: { value : new THREE.Color(debugObject.surfaceColor) },
        uDepthColor: { value : new THREE.Color(debugObject.depthColor) },
        uColorOffset: { value : -0.39},
        uColorMultiplier: { value : 0.45}
    }
})

// Debug
// Create a folder for small waves controls
const bigWavesFolder = gui.addFolder('Big Waves');
bigWavesFolder.close();
bigWavesFolder.add(waterMaterial.uniforms.uBigWavesElevation, 'value', 0.01, 0.4, 0.01).name('uBigWavesElevation')
bigWavesFolder.add(waterMaterial.uniforms.uBigWavesFrequency.value, 'x', 0.0, 10, 0.01).name('uBigWavesFrequencyX')
bigWavesFolder.add(waterMaterial.uniforms.uBigWavesFrequency.value, 'y', 0.0, 10, 0.01).name('uBigWavesFrequencyY')
bigWavesFolder.add(waterMaterial.uniforms.uBigWavesSpeed, 'value', 0.0, 4, 0.01).name('uBigWavesSpeed')

// Create a folder for small waves controls
const smallWavesFolder = gui.addFolder('Small Waves');
smallWavesFolder.close();
smallWavesFolder.add(waterMaterial.uniforms.uSmallWavesElevation, 'value', 0.01, 0.4, 0.01).name('uSmallWavesElevation')
smallWavesFolder.add(waterMaterial.uniforms.uSmallWavesFrequency, 'value', 0.0, 10, 0.01).name('uSmallWavesFrequency')
smallWavesFolder.add(waterMaterial.uniforms.uSmallWavesSpeed, 'value', 0.0, 4, 0.01).name('uSmallWavesSpeed')
smallWavesFolder.add(waterMaterial.uniforms.uSmallWavesIteration, 'value', 0.0, 10, 1).name('uSmallWavesIteration')

// Create a folder for foam
const foamFolder = gui.addFolder('Foam');
foamFolder.close();
foamFolder.add(waterMaterial.uniforms.uFoamBrightness, 'value', 0.01, 20, 0.01).name('uFoamBrightness')
foamFolder.add(waterMaterial.uniforms.uFoamOffset, 'value', 0.0, 2, 0.01).name('uFoamOffset')

// Create a folder for small waves controls
const colorsFolder = gui.addFolder('Colors');
colorsFolder.close();
colorsFolder
    .addColor(debugObject, 'surfaceColor')
    .name('uSurfaceColor')
    .onChange(() => {
        waterMaterial.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor)
    })

colorsFolder
    .addColor(debugObject, 'depthColor'  )
    .name('uDepthColor')
    .onChange(() => {
        waterMaterial.uniforms.uDepthColor.value.set(debugObject.depthColor)
    })

colorsFolder.add(waterMaterial.uniforms.uColorOffset, 'value', -0.5, 0.5, 0.01).name('uColorOffset')
colorsFolder.add(waterMaterial.uniforms.uColorMultiplier, 'value', 0, 4, 0.01).name('uColorMultiplier')

// Mesh
const water = new THREE.Mesh(waterGeometry, waterMaterial)
water.rotation.x = - Math.PI * 0.5
scene.add(water)

/**
 * Floor
 */

const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(1000, 1000),
    new THREE.MeshBasicMaterial({color:'black'})
)
floor.position.y = - 1
floor.rotation.x = - Math.PI / 2
scene.add(floor)

/**
 * Moon
 */

const moon = new THREE.Mesh(
    new THREE.SphereGeometry(),
    new THREE.MeshBasicMaterial()
)
moon.position.z = -15
moon.position.y = 3
scene.add(moon)

/** 
 *  Stars 
 */
// Geometry 
const particlesGeometry = new THREE.BufferGeometry
const amountOfStars = 10000
const spaceScale = 150

const positions = new Float32Array(amountOfStars * 3) // create an empty array for positions
const colors = new Float32Array(amountOfStars * 3) // crerate an empty array for colors

for(let i = 0; i < amountOfStars * 3; i++) // Multiply by 3 for same reason
{
    positions[i] = (Math.random() - 0.5) * spaceScale
    colors[i] = ( Math.random() + 2 ) / 3
}

particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3)) 
particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))

//  Material 
const particlesMaterial = new THREE.PointsMaterial()
particlesMaterial.size = 0.1
particlesMaterial.sizeAttenuation = true

//  Points 
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 0.5, 2)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Enable gamma correction
// renderer.gammaOutput = true;
// renderer.gammaFactor = 2.2;

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    waterMaterial.uniforms.uTime.value = elapsedTime

    // Update stars
    particles.rotation.z = elapsedTime * 0.05

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()